/**
 * @name Lottie
 */

/**---------------------------------- @name common */
export const animation_man = require('./animation/man.json')
export const bar_test = require('./animation/bar_test.json')
export const loading_round = require('./animation/loading_round.json')
export const auth_visual = require('./animation/auth_visual.json')
